import { CrossType } from "./types";

const ZONES: Record<string, string> = {
    '8878': 'ZONE_1',
    '2802': 'ZONE_2',
    '32029': 'ZONE_2',
    '15033': 'ZONE_2',
    '22279': 'ZONE_2',
    '9023': 'ZONE_2.1',
    '9499': 'ZONE_2.1',
    '9114': 'ZONE_2.1',
    '9157': 'ZONE_2.1',
    '9165': 'ZONE_2.1',
    '9233': 'ZONE_2.1',
    '9502': 'ZONE_2.1',
    '9691': 'ZONE_2.1',
    '9446': 'ZONE_2.1',
    '9501': 'ZONE_2.1',
    '12350': 'ZONE_2.2',
    '28419': 'ZONE_3',
    '2811': 'ZONE_3.1',
    '7449': 'ZONE_3.1',
    '28404': 'ZONE_4.1',
    '7131': 'ZONE_4.1',
    '8921': 'ZONE_4.2',
    '137': 'ZONE_4.2',
    '28420': 'ZONE_4.1',
    '27937': 'ZONE_4.1',
    '5197': 'ZONE_4.1',
    '8340': 'ZONE_4.1',
    '23693': 'ZONE_4.1',
    '2805': 'ZONE_4.1',
    '27941': 'ZONE_4.1',
    '10398': 'ZONE_4.1',
    '4424': 'ZONE_4.1',
    '16162': 'ZONE_4.1',
    '11130': 'ZONE_4.1',
    '28402': 'ZONE_4.1',
    '1487': 'ZONE_4.2',
    '28422': 'ZONE_4.1',
    '4503': 'ZONE_4.1',
    '7563': 'ZONE_4.1',
    '14051': 'ZONE_4.1',
    '3157': 'ZONE_4.1',
    '3279': 'ZONE_4.1',
    '16683': 'ZONE_4.2',
    '18053': 'ZONE_4.1',
    '27364': 'ZONE_4.1',
    '11373': 'ZONE_4.1',
    '28200': 'ZONE_4.1',
    '4810': 'ZONE_4.1',
    '20608': 'ZONE_4.1',
    '6682': 'ZONE_4.2',
    '24307': 'ZONE_4.1',
    '25267': 'ZONE_4.1',
    '25847': 'ZONE_4.2',
    '27214': 'ZONE_4.1',
    '19459': 'ZONE_4.2',
    '23106': 'ZONE_4.2',
    '28442': 'ZONE_6',
};

const ZONE_TO_DEFAULT_INSURANCE_AMOUNT: Record<string, number> = {
    'ZONE_1': 3000000,
    'ZONE_2': 2500000,
    'ZONE_2.1': 2500000,
    'ZONE_2.2': 2500000,
    'ZONE_3': 1500000,
    'ZONE_3.1': 1500000,
    'ZONE_4.1': 1000000,
    'ZONE_4.2': 1000000,
    'ZONE_5': 1000000,
    'ZONE_6': 2500000,
};

export function getUsageZone(id: string): string {
    return ZONES[id] || 'ZONE_5';
}

export function getLegkyiZahystDefaultByZone(usageZoneId: string): string | null {
    const zone = getUsageZone(usageZoneId);
    const amount = ZONE_TO_DEFAULT_INSURANCE_AMOUNT[zone];
    if (!amount) return null;
    return `${CrossType.LegkyiZahyst}Premium_${amount}`;
}
